// extracted by mini-css-extract-plugin
export default {"check":"Checkbox--check--0kJPm","noInput":"Checkbox--noInput--AAvOt"};